import * as Yup from 'yup';
import { useEffect } from 'react';
import { Person } from 'services/person/person.types';

export const FormErrorMessages = {
    min_characters: 'Nombre de caractères insuffisant.',
    max_characters: 'Nombre de caractères trop important.',
    email_invalid: 'E-mail invalide.',
    required: 'Ce champ est obligatoire.',
    genre_invalid: 'Genre invalide.',
    born_date_invalid: 'Date de naissance invalide.',
    phone_invalid: 'Numéro de téléphone invalide.',
    source_invalid: 'Source invalide.',
    zipcode_invalid: 'Code postal invalide.',
    status_invalid: 'Statut invalide.',
    disorder_invalid: 'Caractéristique invalide.',
    email_exists: 'Cette adresse e-mail est déjà utilisée.',
    phone_exists: 'Ce numéro de téléphone est déjà utilisé.',
    color_invalid: 'Couleur invalide.',
    role_invalid: 'Rôle invalide.',
    department_invalid: 'Département invalide.',
    invalid_date: 'Date invalide.',
    action_invalid: 'Action invalide.',
    target_invalid: 'Cible invalide.',
    partner_invalid: 'Partenaire invalide.',
    category_invalid: 'Veuillez sélectionner une catégorie valide',
    communication_type_invalid: 'Veuillez sélectionner un type de communication valide',
    informative_reunion_supervisor_invalid: 'Le superviseur de la réunion informative est invalide.',
    informative_reunion_appv_invalid: 'L\'approbateur de la réunion informative est invalide.',
    informative_reunion_location_invalid: 'Le lieu de la réunion informative est invalide.',
    informative_reunion_department_invalid: 'Le département de la réunion informative est invalide.',
    informative_reunion_date_invalid: 'La date de la réunion informative est invalide.',
    informative_reunion_status_invalid: 'Le statut de la réunion informative est invalide.',
};

export const nameSchema = Yup.string()
    .min(3, FormErrorMessages.min_characters)
    .max(50, FormErrorMessages.max_characters)
    .required(FormErrorMessages.required);

export const phoneSchema = Yup.string()
    .matches(/^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/, FormErrorMessages.phone_invalid)
    .required(FormErrorMessages.required);